import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { whatsapp } from "../../assets";

const WhatsAppButton = ({
  phoneNumber = "+2348115371014",
  message = "Hello! I’d love to learn more about your tech programs at Zulfah.",
  className = "",
}) => {
  const [showButton, setShowButton] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Detect scroll progress to show button
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      setShowButton(scrollPercent > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <AnimatePresence>
      {showButton && (
        <motion.div
          key="whatsapp-button"
          className="fixed bottom-6 right-6 z-50 cursor-pointer"
          initial={{ opacity: 0, y: 80, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 80, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 80, damping: 12 }}
        >
          <motion.div
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            className="relative flex items-center justify-center"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            {/* Glow pulse behind */}
            <motion.div
              className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 blur-md"
              animate={{ scale: [1, 1.3, 1], opacity: [0.4, 0.7, 0.4] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />

            {/* Tooltip */}
            <AnimatePresence>
              {showTooltip && (
                <motion.div
                  initial={{ opacity: 0, y: 10, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: 10, scale: 0.95 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="absolute right-16 bg-white text-gray-800 text-sm font-medium shadow-md rounded-lg px-3 py-2 whitespace-nowrap border border-gray-200"
                >
                  💬 Ask Us Your Questions
                  <div className="absolute -right-1 top-1/2 transform -translate-y-1/2 rotate-45 w-3 h-3 bg-white border-r border-b border-gray-200" />
                </motion.div>
              )}
            </AnimatePresence>

            {/* Main Button */}
            <motion.button
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.96 }}
              onClick={handleClick}
              className={`relative flex items-center gap-3 px-5 py-3 rounded-full bg-[#25D366] text-white font-semibold shadow-lg hover:shadow-2xl hover:bg-[#20bd5a] transition-all ${className}`}
            >
              <img
                src={whatsapp}
                alt="WhatsApp"
                className="w-7 h-7 sm:w-6 sm:h-6 drop-shadow-md"
              />
              <span className="hidden sm:inline-block text-[15px] font-medium">
                Ask Us Your Questions
              </span>
            </motion.button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppButton;
